import React from "react"
import { values, isEmpty } from "lodash"
import Ajax from "superagent"

import "./ResumePage.less"

// (${drinks[reservation.id].chName})
// (${drinks[reservation.id].name})

const renderList = (menus, selectedMenus) => (
  values(selectedMenus).map(reservation => (
    reservation.count != 0 
      && (
        <div className="item">
          <div className="count">{reservation.count} x</div>
          <div className="description">
            <p>{menus[reservation.id].name}</p>
            <p>{menus[reservation.id].chName}</p>
          </div>
        </div>
      )
  ))
)

class ResumePage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    Ajax
      .get(`/getreservation?id=${this.props.match.params.id}`)
      .then(res => {
        this.setState({...res.body})
      })
  }

  render() {
    if (isEmpty(this.state)) return <div className="loading">Cargando...</div>

    return (
      <div className="resume-page">

        <header>
          <img src="/static/logo_no_letters.png" />
          <h1>感谢您使用ChineSpain预订!</h1>
        </header>

        <section>
          <p>你必须在{this.state.shift}在{this.state.day}日去餐馆</p>
          <p>把这个屏幕显示给服务员拿到桌子</p>
        </section>

        <section>
          <p>Esta reserva ha sido realizada y pagada por <b>ChineSpain</b>.</p>
          <p>Si hay algún problema o duda, por favor llame el numero de telefono <b>655656548</b>.</p>
        </section>

        <table>
          <tbody>
            <tr>
              <th>Nombre</th>
              <td>{this.state.name}</td>
            </tr>
            <tr>
              <th>Fecha de reserva</th>
              <td>{this.state.day}</td>
            </tr>
            <tr>
              <th>Hora de reserva</th>
              <td>{this.state.shift}</td>
            </tr>
          </tbody>
        </table>

        <main>
          <div className="title">
            <div className="centerme">
              <h1>Menú reservado</h1>
              <h2>保留菜单</h2>
            </div>
          </div>
          {renderList(this.state.product.menus, this.state.menus || {})}
          {renderList(this.state.product.drinks, this.state.drinks || {})}
        </main>

      </div>
    )
  }
}

export default ResumePage



// WEBPACK FOOTER //
// ./src/app/catalogo/components/ResumePage.jsx